import React, { useEffect, useState, useLayoutEffect } from 'react';
import Button from '../../../components/controls/button';
import Style from './ResetPassword.module.css';
import Checkmark from '../../../assets/svg/CheckmarkGray.svg';
import CheckmarkGreen from '../../../assets/svg/Checkmark.svg';
import Dismiss from '../../../assets/svg/Dismiss.svg';
import HanshiWhiteLogo from '../../../assets/hanshi/full-white-sm.svg';
import CustomInput from "../../../components/controls/input/customInput/CustomInput";
import { getDecryptedCookie } from '../../../utils/cookieUtils';
import { useHistory } from "react-router";
import { set } from 'lodash';
import { useDispatch } from 'react-redux';
import { generalActions } from '../../../store/actions';
import { use } from 'react';


const ResetPassword = (props) => {
  const {
    updatePasswordRequest,
    resetErrorMesage,
    resetPasswordResponse,
    resetLoginActionsRequest,
    isLoading,
    isPasswordResetRequired,
    passwordResetToken
  } = props;

  const [title, setTitle] = useState('Reset password');
  const [description, setDescription] = useState('Enter a secure password to protect your account');
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [currentPasswordError, setCurrentPasswordError] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [email, setEmail] = useState(null);
  const [token, setToken] = useState(null);
  const [userToken, setUserToken] = useState(null);
  const domain = getDecryptedCookie("domain");
  const history = useHistory();
  const dispatch = useDispatch();

  const [validationResults, setValidationResults] = useState({
    length: false,
    mixLettersNumbers: false,
    specialCharacter: false,
    mixCase: false,
  });

  useEffect(() => {
    resetErrorMesage();
    setEmail(null);
    setToken(null);

    if (!domain) {
      handleCancel();
    }
    if (isPasswordResetRequired && passwordResetToken) {
      try {
        const decodedData = JSON.parse(atob(passwordResetToken));
        setTitle('Update your password');
        setDescription('You need to update your password before you can continue using your account');
        setToken(decodedData.token);
        setUserToken(decodedData.userToken);
      }
      catch (error) {
        handleCancel();
      }
    }
    else {
      const queryParams = new URLSearchParams(window.location.search);
      const encodedData = queryParams.get("q");
      if (encodedData) {
        try {
          const decodedUrlData = JSON.parse(atob(encodedData));
          setEmail(decodedUrlData.email);
          setToken(decodedUrlData.token);
        }
        catch (error) {
          handleCancel();
        }
      }
      else {
        handleCancel();
      }
    }

  }, []);

  useEffect(() => {
    if (resetPasswordResponse && !isLoading) {
      if(!resetPasswordResponse.isSuccess){
        if(resetPasswordResponse.message === "New password cannot match the current password" || resetPasswordResponse.message === "Invalid current password"){
          setCurrentPasswordError(resetPasswordResponse.message);
        }      
        else{
          dispatch(
            generalActions.showToast({
              title: resetPasswordResponse.message,
              type: "error",
            })
            
          );
        }
      }
      else{
        dispatch(
          generalActions.showToast({
            title: resetPasswordResponse.message,
            type: "success",
          })
          
        );
        setTimeout(() => {
          handleCancel();
        }, 1000);
      }
    }
  }, [resetPasswordResponse]);

  const handleCancel = () => {
    resetLoginActionsRequest();
    history.push('/');
  };
  const handleUpdatePassword = async () => {
    if (password !== confirmPassword) {
      setPasswordError("Passwords don't match");
    } else {
      setPasswordError('');
      setCurrentPasswordError('');
      var data = isPasswordResetRequired ?
      {
        payload: {
          currentPassword: currentPassword,
          newPassword: password,
          token: token,
          userToken: userToken
        },
        domain: domain,
        isForcedReset: true
      } 
      :
      {
        payload: {
          password: password,
          email: email,
          token: token
        },
        domain: domain,
      };
        
      updatePasswordRequest(data);
    }
  };

  useEffect(() => {
    if (
      validationResults.length &&
      validationResults.mixLettersNumbers &&
      validationResults.specialCharacter &&
      validationResults.mixCase
    ) {
      setDisabled(false);
    }
  }, [validationResults, password, confirmPassword]);

  const handleCurrentPasswordChange = (e) => {
    setCurrentPassword(e);
    setCurrentPasswordError('');
  }
  const handleNewPasswordChange = (e) => {
    setPassword(e);
    // Regular expressions for validation criteria
    const lengthRegex = /.{8,}/;
    const mixLettersNumbersRegex = /(?=.*[A-Za-z])(?=.*\d)/;
    const specialCharacterRegex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
    const mixCaseRegex = /(?=.*[a-z])(?=.*[A-Z])/;
    // Update validation results
    setValidationResults({
      length: lengthRegex.test(e),
      mixLettersNumbers: mixLettersNumbersRegex.test(e),
      specialCharacter: specialCharacterRegex.test(e),
      mixCase: mixCaseRegex.test(e),
    });
  };

  return (
    <div className={Style.mainWrapper}>
      <div className={Style.card}>
        <div className="w-full flex justify-center pt-10 mb-5">
          <img src={HanshiWhiteLogo} alt="Hanshi Logo" className="w-32 md:w-48" />
        </div>
        <div className={Style.cardContent}>
          <div className={Style.cardTitleContainer}>
            <p className={`${Style.cardTitle} text-xl-700`}>{title}</p>
            <p className={`${Style.cardDescription} text-sm-500`}>{description}</p>
          </div>
          <div>
            {
              isPasswordResetRequired &&
              <>
              <div className={Style.passwordFieldWrapper}>
                <CustomInput
                  inputClass={Style.passwordInput}
                  labelClass={Style.passwordLabel}
                  isRequired
                  type="password"
                  label="Current Password"
                  dir={true}
                  icon={true}
                  handleChange={handleCurrentPasswordChange}
                />
              </div>
              <p className={Style.errorMessage}>{currentPasswordError}</p>
              </>
              
            }
            <div className={Style.passwordFieldWrapper}>
              <CustomInput
                inputClass={Style.passwordInput}
                labelClass={Style.passwordLabel}
                isRequired
                type="password"
                label="New Password"
                dir={true}
                icon={true}
                handleChange={handleNewPasswordChange}
              />
            </div>
            <div>
              <CustomInput
                inputClass={Style.passwordInput}
                labelClass={Style.passwordLabel}
                isRequired
                type="password"
                label="Confirm Password"
                handleChange={setConfirmPassword}
              />
            </div>
            <p className={Style.errorMessage}>{passwordError}</p>
          </div>
          <div className={Style.validationStrength}>
            <ul>
              <li style={{ color: password.length === 0 ? '#383838' : validationResults.length ? '#107C10' : '#B10E1C' }}>
                <div className='d-flex justify-content-start align-items-center'>
                  <img src={password.length === 0 ? Checkmark : validationResults.length ? CheckmarkGreen : Dismiss} alt="" />
                  <p className='mb-0 ml-3 font-family-imp'>At least 8 characters</p>
                </div>
              </li>
              <li style={{ color: password.length === 0 ? '#383838' : validationResults.mixLettersNumbers ? '#107C10' : '#B10E1C' }}>
                <div className='d-flex justify-content-start align-items-center'>
                  <img src={password.length === 0 ? Checkmark : validationResults.mixLettersNumbers ? CheckmarkGreen : Dismiss} alt="" />
                  <p className='mb-0 ml-3 font-family-imp'>Mix of letter and numbers</p>
                </div>
              </li>
              <li style={{ color: password.length === 0 ? '#383838' : validationResults.specialCharacter ? '#107C10' : '#B10E1C' }}>
                <div className='d-flex justify-content-start align-items-center'>
                  <img src={password.length === 0 ? Checkmark : validationResults.specialCharacter ? CheckmarkGreen : Dismiss} alt="" />
                  <p className='mb-0 ml-3 font-family-imp'>At least 1 special character</p>
                </div>
              </li>
              <li style={{ color: password.length === 0 ? '#383838' : validationResults.mixCase ? '#107C10' : '#B10E1C' }}>
                <div className='d-flex justify-content-start align-items-center'>
                  <img src={password.length === 0 ? Checkmark : validationResults.mixCase ? CheckmarkGreen : Dismiss} alt="" />
                  <p className='mb-0 ml-3 font-family-imp'>At least one lower and one upper case letter</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className={Style.btnWrapper}>
          <Button
            btnClass="btn_w100 btn_w100_primary"
            label="Update Password"
            clickHandler={handleUpdatePassword}
            showLoading={isLoading}
            isDisabled={disabled || isLoading} />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;